import React from 'react';
import '../../styles/landing/landing.scss';
import Grid from '@material-ui/core/Grid';

class TermsItem extends React.Component {
  render() {
    return (
      <Grid
        spacing={0}
        container
        //alignItems={'center'}
        justify={'center'}
        spacing={0}
        className="template-terms-row"
      >
        <Grid
          item
          xs={3}
          className={
            this.props.olTitle
              ? this.props.olTitle2
                ? 'template-terms-row-title '
                : 'template-terms-row-title ol-title'
              : 'template-terms-row-title'
          }
        >
          {this.props.title}
        </Grid>
        <Grid
          item
          xs={9}
          className={
            this.props.olTitle
              ? 'template-terms-row-description'
              : 'template-terms-row-description first-description'
          }
        >
          {this.props.children}
        </Grid>
      </Grid>
    );
  }
}

export default TermsItem;
